import React from "react";
import Typography from "material-ui/Typography";

export default function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}



// WEBPACK FOOTER //
// ./src/components/controls/TabContainer.js